import Impressions from '@common/Tracking/Impressions/Impressions';
import { trackPromoClick, trackPromoView } from '@helpers/analytics';
import { isIntersectionObserverSupported } from '@helpers/browser';

const buildTrackingFromElement = ({
    dataset: {
        trackingId: id,
        trackingCreative: creative = '',
        trackingName: name = '',
        trackingPosition: position = ''
    } = {}
}) => ({
    id, creative, name, position
});

export const trackBannerImpressions = () => {
    if (!isIntersectionObserverSupported()) {
        return;
    }

    const parentElement = document.querySelector('.inlisting-banner');

    if (parentElement) {
        document
            .querySelectorAll('[data-tracking-id]')
            .forEach((element) => {
                if (!element.classList.contains('impression-banner')) {
                    element.classList.add('impression-banner');

                    element.addEventListener('click', () => {
                        trackPromoClick(buildTrackingFromElement(element));
                    });
                }
            });

        const bannerImpressionsInstance = new Impressions(
            'inlisting-banner',
            'impression-banner',
            window.snowplow_boozt,
            (target) => {
                trackPromoView(buildTrackingFromElement(target));
            },
            () => { }
        );
        bannerImpressionsInstance.init();
    }
};
